import clsx from 'clsx'

import { Icon } from '@fv/client-components'
import { fvDate } from '@fv/dates'

type Message = {
  author: {
    email?: string
    name?: string
    role: string
  }
  createdDate: string
  messageText: string
}
type Props = {
  message: Message
}

export const MessageRow = ({ message }: Props) => {
  const { author, createdDate, messageText } = message
  const isSystemMessage = !author.name && !author.email

  return (
    <div
      className={clsx('speech-bubble pt-8', {
        'speech-bubble--me': author.role === 'carrier',
        'speech-bubble--them': author.role !== 'carrier',
      })}
    >
      <span className="whitespace-pre-wrap">{messageText}</span>

      <div className="time-stamp--speech-bubble text-xs leading-[1.4rem] w-full border-b border-fv-gray">
        <Icon
          icon={isSystemMessage ? 'server' : 'user-circle'}
          className="color-dark"
        />
        <span className="messages-username">
          {isSystemMessage ? 'System' : (author.name ?? author.email)}
        </span>
        <span>/</span>
        <span>{formatDate(createdDate)}</span>
      </div>
    </div>
  )
}

function formatDate(date: string) {
  const dayjsDate = fvDate(date)

  if (dayjsDate.isAfter(fvDate().startOf('day'))) {
    return `Today @ ${dayjsDate.format('h:mm a')}`
  } else if (dayjsDate.isAfter(fvDate().startOf('day').subtract(1, 'day'))) {
    return `Yesterday @ ${dayjsDate.format('h:mm a')}`
  }

  return `${dayjsDate.format('MMM Do')} @ ${dayjsDate.format('h:mm a')}`
}
